import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "AuthorDetails",
    component: () => (__SERVER__ ? require("./author-details-view") : import("./author-details-view"))
});

export default definition;
